import { c as _c } from "react/compiler-runtime";
import type { TenantScope } from '@onefootprint/request-types/dashboard';
import useGetRoleText from './use-get-role-text';
type RolePermissionsProps = {
  scopes: TenantScope[];
  name: string;
};
const RolePermissions = t0 => {
  const $ = _c(9);
  const {
    scopes
  } = t0;
  const getRoleText = useGetRoleText();
  let t1;
  if ($[0] !== getRoleText || $[1] !== scopes) {
    let t2;
    if ($[3] !== getRoleText) {
      t2 = scope => getRoleText(scope);
      $[3] = getRoleText;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = new Set(scopes.map(t2));
    $[0] = getRoleText;
    $[1] = scopes;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = [...t1];
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const scopesText = t2;
  let t3;
  if ($[7] !== scopesText) {
    t3 = <div className="flex flex-col items-start gap-3"><div className="grid justify-between grid-cols-1 sm:grid-cols-2 gap-5 gap-y-3">{scopesText.map(_temp)}</div></div>;
    $[7] = scopesText;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export default RolePermissions;
function _temp(scopeText) {
  return <div key={scopeText} className="text-body-2">{scopeText}</div>;
}